export const STUDIO_CRUD = 'studio.crud';
export const STUDIO_ADMIN_CRUD = 'studio.admin.crud';
export const STUDIO_USERS_CRUD = 'studio.users.crud';
export const STUDIO_FINANCIALS_READ = 'studio.financials.read';
